<template>
  <Service color="green">
    <template slot="message">
      <p>Isj! Noe gikk galt.</p>
    </template>
    <template slot="text">
      Vi kunne dessverre ikke åpne denne boka. Det kan være flere årsaker til problemet, men forsøk å gå til <a href="https://www.cappelendammundervisning.no/cdu/mypage/mypage.action#/products" title="Gå til min side">min side</a> på cdu.no og åpne boka derfra.
    </template>
  </Service>
</template>

<script>
import Service from './Service'
export default {
  components: {
    Service
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/service/NotFound.vue